import { render, staticRenderFns } from "./djgsp.vue?vue&type=template&id=0cee4d97&scoped=true&"
import script from "./djgsp.vue?vue&type=script&lang=js&"
export * from "./djgsp.vue?vue&type=script&lang=js&"
import style0 from "./djgsp.vue?vue&type=style&index=0&id=0cee4d97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cee4d97",
  null
  
)

export default component.exports